import {
  BoardFloorDto,
  BoardPurchaseFloorInterface,
  BoardPurchaseInterface,
  JobCreateDto,
  MaterialInterface,
  ModelBoardPurchaseDto,
} from '@vatos-pas/common';
import { EditorState } from 'draft-js';

export type BoardExcelFloorBaseDto = Pick<
  BoardFloorDto,
  'floor' | 'quantity' | 'boardTypeId' | 'boardType'
>[];

export type MaterialDto = Pick<MaterialInterface, 'name' | 'unit' | 'amount'>;

export type BoardDto = Pick<
  BoardPurchaseFloorInterface,
  'floor' | 'boardTypeId' | 'quantity'
>;

export type PurchaseOrderFieldsType = {
  boardPurchaseFloors?: BoardDto[];
  materials?: MaterialDto[] | [];
} & Pick<
  BoardPurchaseInterface,
  | 'orderNumber'
  | 'dateExpected'
  | 'supplierId'
  | 'laborOnly'
  | 'isReplacement'
  | 'notesForSupplier'
  | 'invoiceNumber'
  | 'orderLabel'
>;

export type ModelBoardPurchaseDtoWithId = {
  id: string;
} & ModelBoardPurchaseDto;

export interface JobCreateFormFields {
  idNumber: string;
  block: string | undefined;
  lot: string;
  communityPhase: string;
  buildingName: string;
  supervisors: any[];
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  builder: string;
  subdivision: string;
  model: string;
  regionId: string;
  highCeiling: boolean;
  garageFirst: boolean;
  screwInspection: boolean;
  hasTrim: boolean;
  hasInteriorOptions?: boolean;
  hasExteriorOptions?: boolean;
  hasTrimOptions?: boolean;
  totalSquareFootage?: number;
  geoDistanceTolerance?: number;
  interiorOptionCost?: number;
  exteriorOptionCost?: number;
  trimOptionCost?: number;
  startingPhaseId?: string;
  startingPhaseApproved?: boolean;
  latitude: number | null;
  longitude: number | null;
}

export type EnhancedJobCreateDto = {
  options: EditorState;
} & JobCreateDto;

export enum SpMatchFields {
  Builder = 'Builder',
  Subdivision = 'Subdivision',
  Model = 'Model',
}

export enum SpMatchFieldsName {
  Builder = 'spBuilderNames',
  Subdivision = 'spSubdivisionNames',
  Model = 'spModelNames',
}

export enum SpMatchFieldsId {
  Builder = 'spOrderBuilderNameId',
  Subdivision = 'spOrderSubdivisionNameId',
  Model = 'spOrderJobPlanId',
}

export enum SpFieldMapping {
  SpOrderBuilderOrderNumber = 'spOrderBuilderOrderNumber',
  SpOrderJobBlock = 'spOrderJobBlock',
  SpOrderJobCity = 'spOrderJobCity',
  SpOrderJobLot = 'spOrderJobLot',
  SpOrderJobPostalCode = 'spOrderJobPostalCode',
  SpOrderJobStreet = 'spOrderJobStreet',
  SpOrderJobStreetSupplement = 'spOrderJobStreetSupplement',
  SpOrderJobStateCode = 'spOrderJobStateCode',
  SpOrderSubdivisionName = 'spOrderSubdivisionName',
}

export enum SpFieldMappingFields {
  IdNumber = 'idNumber',
  Block = 'block',
  City = 'city',
  Lot = 'lot',
  Zip = 'zip',
  Address1 = 'address1',
  Address2 = 'address2',
  State = 'state',
  CommunityPhase = 'communityPhase',
}
